import React, { useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Mensaje, MensajeCapcha, MensajeSiNo } from "../mensajes";
import { Dimmer } from "../spinner";
import { ValidCaptcha } from "../../util/varios";
import axios from "axios";

import { Input } from "../../ui/inputs/Input";
import { DangerButton, SuccessButton } from "../../ui/buttons/Button";

export const CambiarClaveSupervisor = (props) => {
  const btnCancela = useRef();
  const btnAcepta = useRef();
  const [mostrar, setMostrar] = useState(false);
  const [deshabilitado, setDeshabilitado] = useState(true);
  const [deshabilitadoL, setDeshabilitadoL] = useState(false);
  const [titulo, setTitulo] = useState();
  const [msg, setMsg] = useState();
  const [mostrar1, setMostrar1] = useState(false);
  const [mostrar3, setMostrar3] = useState(false);
  const [mostrar4, setMostrar4] = useState(false);
  const [titulo2, setTitulo2] = useState();
  const [msg2, setMsg2] = useState();
  const [activate, setActivate] = useState(false);
  const [contar, setContar] = useState(0);
  const [mostrarClave, setMostrarClave] = useState(false);
  const [mostrarClave1, setMostrarClave1] = useState(false);
  const [tecla, setTecla] = useState();
  const [desde, setDesde] = useState(0);
  const txtLogin = useRef();
  const txtPassword = useRef();
  const txtConfirmPassword = useRef();
  let op = require("../../../src/modulos/datos");
  let token = localStorage.getItem("jwtToken");
  const procesarRegistro = (body) => {
    let endpoint = `${op.conexion}/api/comun/cambioclavesupervisor`;
    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setActivate(false);
          setDesde(3);
          setTitulo("Cambiar Contraseña");
          setMsg("La Contraseña fue cambiada.");
          setMostrar(true);
        }
      })
      .catch(function (error) {
        setTitulo("ERROR");
        setMsg(error.response.data.message);
        setMostrar(true);
        setActivate(false);
      });
  };
  const SelectUsuario = (login) => {
    let endpoint = `${op.conexion}/api/comun/selectusuariologin?login=${login}`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        if (response.status == 200) {
          setActivate(false);
          if (response.data.idusuario > 0) {
            setDeshabilitado(false);
            setDeshabilitadoL(true);
            txtLogin.current.value = response.data.login;
            txtPassword.current.focus();
            /* if (tecla === 13) {
              setTimeout(() => {
                txtPassword.current.focus();
              }, 100);
            } */
          } else {
            setTitulo("Error");
            setMsg("error al cargar el usuario");
            setMostrar(true);
            setActivate(false);
          }
        }
      })
      .catch((error) => {
        setTitulo("ERROR");
        setMsg(error.response.data.message);
        setMostrar(true);
        setActivate(false);
      });
  };
  const blanquear = () => {
    setMostrar(false);
    setTitulo("");
    setMsg("");
    setMostrar1(false);
    setTitulo2("");
    setMsg2("");
    setActivate(false);
    setContar(0);
  };
  const handleCloseMensa = () => {
    setMostrar(false);
    if (desde === 3) {
      setMostrar(false);
      if (props.onHideCancelar) { props.onHideCancelar(); }
      if (props.setShow) props.setShow(false);
      props.setTabla(0);

    }
    setDesde(0);
  };
  const cancelar = () => {
    blanquear();
    if (props.onHideCancelar) { props.onHideCancelar(); }
    if (props.setShow) props.setShow(false);
    props.setTabla(0)
  };
  const validarCapcha = () => {
    var valido = ValidCaptcha();
    if (valido) {
      setMostrar4(false);
      setTitulo("Corfirmar");
      setMsg("Esta seguro de registrar el ejercicio fiscal con estos datos?");
      setMostrar3(true);
    }
  };
  const handleCancelaCapcha = () => {
    setMostrar4(false);
  };
  const handleCloseNo = () => {
    setMostrar3(false);
  };
  const handleCloseSi = () => {
    setMostrar3(false);
  };
  const seleccionarUsuario = () => {
    setContar(0);
    setActivate(true);
    SelectUsuario(txtLogin.current.value);
  };
  const onChangeValidar = (e) => {
    e.preventDefault();
    var sigue = true;
    if (txtLogin.current.value.trim() === "") {
      setTitulo("Error");
      setMsg("El Usuario no debe estar vacio");
      sigue = false;
      txtLogin.current.focus();
    } else if (txtPassword.current.value.trim() === "") {
      setTitulo("Error");
      setMsg("La Contraseña no debe estar vacia");
      sigue = false;
      txtPassword.current.focus();
    } else if (txtConfirmPassword.current.value.trim() === "") {
      setTitulo("Error");
      setMsg("La Confirmación de la Contraseña no debe estar vacia");
      sigue = false;
      txtConfirmPassword.current.focus();
    } else if (
      txtPassword.current.value.trim() !==
      txtConfirmPassword.current.value.trim()
    ) {
      setTitulo("Error");
      setMsg("Las Contraseñas no coinciden");
      sigue = false;
      txtConfirmPassword.current.focus();
    }
    if (sigue) {
      setActivate(true);
      setContar(0);
      let body = {
        passwd: txtPassword.current.value,
        login: txtLogin.current.value,
        supervisor: props.supervisor,
      };
      procesarRegistro(body);
    } else {
      setMostrar(true);
    }
  };
  const handleInputChange = (event) => {
    setTecla(event.which);
    if (event.which === 13) {
      if (event.target.id === "inputLogin") {
        seleccionarUsuario();
      } else if (event.target.id === "inputPassword") {
        if (
          txtConfirmPassword.current.value !== "" &&
          txtPassword.current.value !== txtConfirmPassword.current.value
        ) {
          setTitulo("Información");
          setMsg("Las Contraseñas no coinciden.");
          setMostrar(true);
          txtPassword.current.focus();
        } else {
          txtConfirmPassword.current.focus();
        }
      } else if (event.target.id === "inputConfirmPassword") {
        if (
          txtConfirmPassword.current.value !== "" &&
          txtPassword.current.value !== txtConfirmPassword.current.value
        ) {
          setTitulo("Información");
          setMsg("Las Contraseñas no coinciden.");
          setMostrar(true);
          txtConfirmPassword.current.focus();
        } else {
          btnAcepta.current.focus();
        }
      }
    } else if (typeof event.which === "undefined") {
      if (event.target.id === "inputPassword") {
        if (
          txtConfirmPassword.current.value !== "" &&
          txtPassword.current.value !== txtConfirmPassword.current.value
        ) {
          setTitulo("Información");
          setMsg("Las Contraseñas no coinciden.");
          setMostrar(true);
        }
      } else if (event.target.id === "inputConfirmPassword") {
        if (
          txtConfirmPassword.current.value !== "" &&
          txtPassword.current.value !== txtConfirmPassword.current.value
        ) {
          setTitulo("Información");
          setMsg("Las Contraseñas no coinciden.");
          setMostrar(true);
        }
      }
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false;
  };
  const mostrarPassword = () => setMostrarClave(!mostrarClave);
  const mostrarPassword1 = () => setMostrarClave1(!mostrarClave1);
  return (
    <Modal
      {...props}
      size="sm"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      onShow={() => {
        txtLogin.current.value = props.login;
        setDeshabilitado(false);
        setDeshabilitadoL(false);
        setDesde(0);
        setTimeout(() => {
          txtPassword.current?.focus();  
        }, 300);
        
        
      }}
    >
      <Modal.Header className="col-12 m-0 px-4 py-2 d-flex justify-content-between text-light rounded-top azulGradiant">
        <h3 className="fw-bold m-0">
          Cambiar Contraseña.
        </h3>
        <a type = 'button'
          ref={btnCancela}
          className="fw-bold text-light fs-6"
          onClick={cancelar}
        >
          Salir <i className="fa fa-times ms-2"></i>
        </a>
      </Modal.Header>
      <Modal.Body>
        <div className="col-12 m-0 p-0">
          <Input
            label="Usuario:"
            autocomplete="off"
            disabled={true}
            id="inputLogin"
            onKeyUp={handleInputChange}
            ref={txtLogin}
          />
        </div>
        <div className="col-12 m-0 my-2 p-0 d-flex">
          <Input
            label="Contraseña:"
            type={mostrarClave ? "text" : "password"}
            disabled={deshabilitado}
            id="inputPassword"
            onKeyUp={handleInputChange}
            ref={txtPassword}
          />
          <button
            disabled={deshabilitado}
            onClick={mostrarPassword}
            className="btn btn-sm btn-light border shadow-none text-dark"
          >
            <i className="fa fa-eye-slash"></i>
          </button>
        </div>
        <div class="col-12 m-0 p-0 d-flex">
          <Input
            label="Confirmar Contraseña:"
            type={mostrarClave1 ? "text" : "password"}
            disabled={deshabilitado}
            className="form-control form-control-sm bg-light "
            id="inputConfirmPassword"
            onKeyUp={handleInputChange}
            ref={txtConfirmPassword}
          />
          <button
            disabled={deshabilitado}
            onClick={mostrarPassword1}
            className="btn btn-sm btn-light border shadow-none text-dark"
          >
            <i className="fa fa-eye-slash"></i>
          </button>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <SuccessButton ref={btnAcepta} onClick={onChangeValidar}>Aceptar</SuccessButton>
        <DangerButton onClick={cancelar}>Cancelar</DangerButton>
      </Modal.Footer>
      <Mensaje
        titulo={titulo}
        mensaje={msg}
        show={mostrar}
        onHide={handleCloseMensa}
      />
      <MensajeCapcha
        show={mostrar4}
        onHideAcepta={validarCapcha}
        onHideCancela={handleCancelaCapcha}
      />
      <MensajeSiNo
        titulo={titulo}
        mensaje={msg}
        show={mostrar3}
        onHideSi={handleCloseSi}
        onHideNo={handleCloseNo}
      />
      <Dimmer active={activate} inverted></Dimmer>
    </Modal>
  );
};
